import { ConversationPlatform } from "../../conversation";

export const supportedAiChannels: ReadonlySet<ConversationPlatform> = new Set([
  ConversationPlatform.EMAIL,
  ConversationPlatform.REDO_CHAT,
  ConversationPlatform.FACEBOOK,
  ConversationPlatform.INSTAGRAM,
  ConversationPlatform.SMS,
  ConversationPlatform.TIKTOK,
]);

export function isAiSupportedChannel(
  platform: ConversationPlatform | undefined,
): boolean {
  if (!platform) {
    return false;
  }
  return supportedAiChannels.has(platform);
}
